import { render, staticRenderFns } from "./tag-sidebar.vue?vue&type=template&id=694f504e&scoped=true&"
import script from "./tag-sidebar.vue?vue&type=script&lang=ts&"
export * from "./tag-sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./tag-sidebar.vue?vue&type=style&index=0&id=694f504e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694f504e",
  null
  
)

export default component.exports